<div class="margin-bottom-20 align-center full-width" *ngIf="(mediumGroups$ | async).length > 1">
    <mat-radio-group>
        <mat-radio-button
            class="padding-top-10 padding-right-20"
            *ngFor="let mediumGroup of mediumGroups$ | async"
            [value]="mediumGroup.display"
            [checked]="selectedMediumGroup.display === mediumGroup.display"
            (change)="mediumTypeSelected(mediumGroup)">
            {{ mediumGroup.display | translate }}
        </mat-radio-button>
    </mat-radio-group>
</div>

<div class="margin-bottom-20 align-center full-width">
    <form [formGroup]="selectMediumForm">
        <mat-form-field
            class="full-width"
            *ngIf="!(allowOnlyAddedCards && this.selectedMediumGroup.type === mediumGroupEnum.Travelcard)"
            appearance="outline">
            <mat-label>{{ label | translate }}</mat-label>
            <mat-icon *ngIf="(visibleCards$ | async)?.length > 0" (click)="onToggleAutocomplete($event)" matSuffix>
                {{ autocompleteTrigger?.panelOpen ? 'expand_less' : 'expand_more' }}
            </mat-icon>

            <input
                #mediumInput
                #autocompleteTrigger="matAutocompleteTrigger"
                [type]="inputType"
                [matAutocomplete]="auto"
                [matAutocompleteDisabled]="mediumAutocompleteDisabled"
                matInput
                placeholder="{{ label | translate }}"
                attr.aria-label="{{ label | translate }}"
                formControlName="medium" />

            <mat-autocomplete
                #auto="matAutocomplete"
                (optionSelected)="setSelectedMedium($event)"
                (closed)="onAutocompleteClosed()"
                autoActiveFirstOption>
                <mat-option *ngFor="let option of visibleCards$ | async" [value]="option.card_nr">
                    {{ option.name }}
                </mat-option>
            </mat-autocomplete>

            <mat-error *ngIf="selectMediumForm.controls.medium.hasError('required')">
                {{ 'FIELD_VALIDATION_REQUIRED' | translate }}
            </mat-error>

            <mat-error *ngIf="selectMediumForm.controls.medium.hasError('email')">
                {{ 'LOCAL_INPUT_VALIDATION_EMAIL' | translate }}
            </mat-error>

            <mat-error *ngIf="selectMediumForm.controls.medium.hasError('pattern')">
                {{ 'FIELD_VALIDATION_CARD_NUMBER_INVALID_FORMAT' | translate }}
            </mat-error>

            <mat-error *ngIf="selectMediumForm.controls.medium.hasError('minlength')">
                {{ 'LOCAL_INPUT_VALIDATION_MIN_LENGTH' | translate }}
            </mat-error>

            <mat-error *ngIf="selectMediumForm.controls.medium.hasError('maxlength')">
                {{ 'LOCAL_INPUT_VALIDATION_MAX_LENGTH' | translate }}
            </mat-error>
        </mat-form-field>

        <mat-form-field
            class="full-width"
            *ngIf="
                allowOnlyAddedCards &&
                this.selectedMediumGroup.type === mediumGroupEnum.Travelcard &&
                (visibleCards$ | async).length
            "
            appearance="outline">
            <mat-label>{{ label | translate }}</mat-label>
            <mat-select (selectionChange)="setSelectedMedium()" formControlName="medium" required>
                <mat-option *ngFor="let option of visibleCards$ | async" [value]="option.card_nr">
                    {{ option.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </form>

    <ng-container
        *ngIf="
            allowOnlyAddedCards &&
            this.selectedMediumGroup.type === mediumGroupEnum.Travelcard &&
            !(visibleCards$ | async).length
        ">
        <p>{{ 'ONLY_ALLOWED_ADDED_CARDS_TEXT' | translate }}</p>
        <button class="btn btn--primary" [routerLink]="'/account/related-cards/add' | localize">
            <span>{{ 'ONLY_ALLOWED_ADDED_CARDS_ADD_BTN' | translate }}</span>
        </button>
    </ng-container>
</div>
